export default __webpack_public_path__ + "static/sceneario-bathroom-e196105e8515b2d3e573e180661c957d.png";